import { render } from "./trend.vue?vue&type=template&id=5d320490&scoped=true"
import script from "./trend.vue?vue&type=script&lang=js"
export * from "./trend.vue?vue&type=script&lang=js"

import "./trend.vue?vue&type=style&index=0&id=5d320490&lang=less&scoped=true"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d320490"]])

export default __exports__